/* eslint-disable @typescript-eslint/no-explicit-any */
import { proxy } from "valtio";
import { getDashboard } from "../apis/dashboard/get.dashboard";
import { getAllInAppPackages } from "../apis/mail-credits/get.all.in.app.packages";
import { getInAppCredits } from "../apis/mail-credits/get.in.app.credits";
import { getAllInitiatorsTransactions } from "../apis/transactions/get.all.initiators.transactions";
import { getUserByParams } from "../apis/user/get.user.by.params";
import { getUserByToken } from "../apis/user/get.user.by.token";
import { getWeddingGuestManager } from "../apis/wedding/get.wedding.guest.manager";
import { getTextAndGifWellWishes } from "../apis/wellwish/get.text.and.gif.well.wishes";
import { Dashboard, DefaultDashboard } from "../types/dashboard";
import {
  createDefaultInAppCredits,
  InAppCredits,
  InAppPackage,
} from "../types/mailcredit";
import { Transaction, TransactionCtx } from "../types/transaction";
import { createDefaultUser, User } from "../types/user";
import { WellWish } from "../types/wellwish";
// import { getAllWellWishes } from "../apis/wellwish/get.all.well.wishes";
import { getNotificationStatus } from "../apis/notifications/get.notification.status";
import { BannerView } from "../pages/Website/layout/components/PreviewTemplates/TemplateTwo/types";
import { UserWeddingRole } from "../types/wedding";
import { ClientStorage, ClientStorageItem } from "../utils/clientstorage";

export const userStore = proxy<{ data: User }>({ data: createDefaultUser() });
export const spouseStore = proxy<{ data: User }>({ data: createDefaultUser() });
export const dashboardStore = proxy<{ data: Dashboard }>({
  data: DefaultDashboard,
});
export const mailCreditsStore = proxy<{
  isMailCreditsDrawerOpen: boolean;
  inAppCredits: InAppCredits;
  inAppPackages: InAppPackage[];
  transactionCount: number;
  transactionList: Transaction[];
  latestCreditsPurchase: number;
}>({
  isMailCreditsDrawerOpen: false,
  inAppCredits: createDefaultInAppCredits(),
  inAppPackages: [],
  transactionCount: 0,
  transactionList: [],
  latestCreditsPurchase: 0,
});

export const fetchMailCredits = ({
  XAccountHash,
  onComplete,
  onError,
}: FetchParams<{
  inAppCredits: InAppCredits;
  inAppPackages: InAppPackage[];
}>) => {
  getInAppCredits({
    headers: {
      "X-Account-Hash": XAccountHash || "",
    },
    onCompleted: (data) => {
      mailCreditsStore.inAppCredits = data.data;
      onComplete(mailCreditsStore);
    },
    onError: (err) => {
      onError(err);
    },
  });

  getAllInAppPackages({
    headers: {
      "X-Account-Hash": XAccountHash || "",
    },
    onCompleted: (data) => {
      mailCreditsStore.inAppPackages = data.data;
      onComplete(mailCreditsStore);
    },
    onError: (err) => {
      onError(err);
    },
  });

  getAllInitiatorsTransactions({
    headers: {
      "X-Account-Hash": XAccountHash || "",
    },
    query: {
      page: 1,
      transactionCtx: TransactionCtx.TxCtxBuyPackage,
    },
    onCompleted(params) {
      mailCreditsStore.transactionCount = params.data.transactionCount;
      mailCreditsStore.transactionList = params.data.transactionList;
    },
    onError(err) {
      console.error(err);
    },
  });
};


export const createDefaultWellWishes = (): WellWishStoreType => ({
  wellWishesCount: 0,
  wellWishes: [],
});


export type Wish = {
  type: "textandgif" | "images";
  name?: string;
  message?: string;
  giphURL?: string;
  caption?: string;
  createdAt: Date;
  images?: string[];
};

type WellWishStoreType = {
  wellWishesCount: number;
  wellWishes: WellWish[];
};
export const wellWishesStore = proxy<{ data: WellWishStoreType }>({
  data: createDefaultWellWishes(),
});
// export const loveWallStore = proxy<{data: WellWishStoreType;}>({ data: createDefaultWellWishes(), });

export type Meta = {
  showOnboardingModal: boolean;
};

export type GuestManager = {
  exists: boolean;
  data: User;
  isGuestManagerDrawerOpen: boolean;
};

export const guestManagerStore = proxy<GuestManager>({
  exists: false,
  data: createDefaultUser(),
  isGuestManagerDrawerOpen: false,
});

export type AddSpouse = {
  spouseRole: UserWeddingRole | null;
  onSpouseDrawerOpen: boolean;
};

export const AddSpouseStore = proxy<AddSpouse>({
  spouseRole: null,
  onSpouseDrawerOpen: false,
});

export const AddEventPlannerStore = proxy({
  spouseRole: null,
  isEventPlannerDrawerOpen: false,
});

export const fetchGuestManager = ({
  XAccountHash,
  onComplete,
  onError,
}: FetchParams<User>) => {
  getWeddingGuestManager({
    headers: {
      "X-Account-Hash": XAccountHash || "",
    },
    onCompleted(params) {
      if (params?.data?._id) {
        guestManagerStore.exists = true;
        guestManagerStore.data = params.data;
        onComplete(params.data);
      }
    },
    onError(err) {
      console.error({ errguestmanager: err });
      onError(err);
    },
  });
};

export const metaStore = proxy<Meta>({
  showOnboardingModal: false,
});

export interface NotificationStatus {
  unreadCount: number;
  isLoading: boolean;
  error: string | null;
}

export const createDefaultNotificationStatus = (): NotificationStatus => ({
  unreadCount: 0,
  isLoading: false,
  error: null,
});

export const notificationStatusStore = proxy<{ data: NotificationStatus }>({
  data: createDefaultNotificationStatus(),
});

export const notificationDrawerStore = proxy({
  isOpen: false,
});

type FetchParams<T> = {
  XAccountHash?: string;
  onComplete: (CurrentData: T) => void;
  onError: (err?: any) => void;
};
export const fetchLoggedInUser = ({
  XAccountHash,
  onComplete,
  onError,
}: FetchParams<User>) => {
  if (userStore.data._id) {
    onComplete(userStore.data);
    return;
  }
  getUserByToken({
    headers: {
      "X-Account-Hash": XAccountHash || "",
    },
    onCompleted: (data) => {
      userStore.data = data.data;
      onComplete(userStore.data);
    },
    onError: (err) => {
      onError(err);
    },
  });
};

export const fetchSpouseUser = (userID: string) => {
  const XAccountHash =
    ClientStorage.fetch(ClientStorageItem.XAccountHash) || "";
  getUserByParams({
    headers: {
      "X-Account-Hash": XAccountHash || "",
    },
    params: userID,
    onCompleted: (data) => {
      spouseStore.data = data.data;
    },
    onError: (err) => {
      console.log(err);
    },
  });
};

export const fetchDashboard = ({
  XAccountHash,
  onComplete,
  onError,
}: FetchParams<Dashboard>) => {
  if (dashboardStore.data.accountName) {
    onComplete(dashboardStore.data);
    return;
  }
  getDashboard({
    headers: {
      "X-Account-Hash": XAccountHash || "",
    },
    onCompleted: (data) => {
      dashboardStore.data = data.data;
      onComplete(dashboardStore.data);
    },
    onError: (err) => {
      onError(err);
    },
  });
};


export const fetchWellWishes = ({
  XAccountHash,
  onComplete,
  onError,
}: FetchParams<WellWishStoreType>) => {
  getTextAndGifWellWishes({
    headers: {
      "X-Account-Hash": XAccountHash || "",
    },
    query: {
      page: 1,
    },
    onCompleted: (data) => {
      wellWishesStore.data = {
        ...wellWishesStore.data,
        ...data.data,
      };
      onComplete(data.data);
    },
    onError: (err) => {
      onError(err);
    },
  });
};

// export const fetchLoveWall = ({
//   onComplete,
//   onError,
// }: FetchParams<WellWishStoreType>) => {
//   getAllWellWishes({
//     query: {
//       page: 1,
//     },
//     onCompleted: (data) => {
//       loveWallStore.data = data.data;
//       onComplete(data.data);
//     },
//     onError: (err) => {
//       onError(err);
//     },
//   });
// };

export const fetchNotificationStatus = ({
  onComplete,
  onError,
}: {
  onComplete: (data: NotificationStatus) => void;
  onError: (err: string) => void;
}) => {
  notificationStatusStore.data = {
    ...notificationStatusStore.data,
    isLoading: true,
    error: null,
  };

  getNotificationStatus({
    onCompleted: ({ data }) => {
      const statusData: NotificationStatus = {
        unreadCount: data.unreadCount,
        isLoading: false,
        error: null,
      };

      notificationStatusStore.data = statusData;
      onComplete(statusData);
    },
    onError: (err) => {
      const errorData: NotificationStatus = {
        ...createDefaultNotificationStatus(),
        error: err || "Failed to fetch notification status",
      };

      notificationStatusStore.data = errorData;
      onError(err || "Failed to fetch notification status");
    },
  });
};

export type ActiveTab =
  | "basics"
  | "love-story"
  | "aso-ebi"
  | "event-schedule"
  | "gallery"
  | "gifting"
  | "q-and-a"
  | "wedding-party";

const savedActiveTab =
  (localStorage.getItem("activeTab") as ActiveTab) || "basics";
const savedBannerView =
  (localStorage.getItem("bannerView") as BannerView) || BannerView.Home;

export const sharedState = proxy({
  activeTab: savedActiveTab,
  bannerView: savedBannerView,
});

export const setActiveTab = (tab: ActiveTab) => {
  sharedState.activeTab = tab;
  localStorage.setItem("activeTab", tab);
};

export const setBannerView = (view: BannerView) => {
  sharedState.bannerView = view;
  localStorage.setItem("bannerView", view);
};
